import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/image/wepay_icon.png'


import BlockView from "@/views/share/BlockView.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'MainWechatMerchantSegView',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_flex = _resolveComponent("a-flex")!

  return (_openBlock(), _createBlock(BlockView, { class: "wechat-merchant-seg-view" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_flex, { vertical: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_typography_title, { level: 5 }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("收款商户", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_a_flex, {
            vertical: "",
            align: "center",
            class: "wmsv-content"
          }, {
            default: _withCtx(() => [
              _cache[4] || (_cache[4] = _createElementVNode("img", {
                src: _imports_0,
                alt: ""
              }, null, -1)),
              _createVNode(_component_a_typography_title, { level: 4 }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("独立微信支付", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_a_typography_text, { type: "secondary" }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode(" 开设独立的微信支付收款账户，关联与主体信息一致的银行对公账户，个体工商可关联法人个人银行卡，资金由微信支付官方提供清分处理，安全有保障！ ", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_router_link, { to: "/account/merchant" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    shape: "round"
                  }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createTextVNode(" 快速申请 ", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})